import React from 'react';
import styled, { css } from 'styled-components';
import SelectDropdown from 'components/Select/Select';
import { theme, toRem } from 'design';
import DropArrow from 'images/icons/caret-down.svg';

export interface IFilterSelectorOption {
  value: string;
  label: string;
  emptyMessage: string;
}

interface IFilterProps<T extends IFilterSelectorOption> {
  options: T[];
  selectedValue: string;
  width?: number;
  onChange(val: T[]): void;
}

const arrowWidth = 7;
const arrowHeight = 5;
const h1ArrowOffset = 11;

const StyledSelectDropdown = styled(SelectDropdown)<Partial<IFilterProps<any>>>`
  .react-dropdown-select {
    border: 0 !important;

    .drop-handle {
      background: transparent !important;
    }

    @media (min-width: ${theme.breakpoint.small}px) {
      padding: 0 ${toRem(theme.layout.gutter.large)};
    }

    &:hover {
      background-color: ${theme.color.white};
      border-color: ${theme.color.white} !important;

      .drop-handle {
        background: transparent !important;
      }
    }

    ${({ width }) =>
      width &&
      css`
        width: ${toRem(width)};
      `}
  }

  .react-dropdown-select-dropdown-handle {
    display: none;
  }

  .react-dropdown-select-content {
    span {
      color: ${theme.color.neutral[900]};
      font-size: ${toRem(16)};
      font-weight: ${theme.font.weight.semiBold};

      &::after {
        content: '';
        width: ${toRem(arrowWidth)};
        height: ${toRem(arrowHeight)};
        margin-left: ${toRem(h1ArrowOffset)};
        background-image: url(${DropArrow});
      }
    }
  }
`;

const FilterSelector = <T extends IFilterSelectorOption>({ options, selectedValue, onChange, width }: IFilterProps<T>) => {
  const selected = options.find((opt) => opt.value === selectedValue);

  return <StyledSelectDropdown options={options} onChange={onChange} values={[selected || options[0]]} width={width} data-cy="filter-selector" />;
};

export default FilterSelector;
